<template>
    <div id="app">
        <Home/>
    </div>
</template>

<script>
    // import db from './firebase/firestore'
    import abilities from './data/abilities.json'
    import Home from './components/Home.vue'

    export default {
        name: 'app',
        components: {
            Home
        },
        created() {
            abilities.forEach(ability => {
                ability.visible = true;
                ability.matched = true;
                // nameの正規化（中黒消す）
                ability.search_name = ability.name
                    .replace(/[・：:\s]/g, '')
                    .replace(/[ぁ-ん]/g, (s) => String.fromCharCode(s.charCodeAt(0) + 0x60))
                    .replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0))
                    .replace(/[Ⅰ]/g, '1')
                    .replace(/[Ⅱ]/g, '2')
                    .replace(/[Ⅲ]/g, '3')
                    .replace(/[Ⅳ]/g, '4')
                    .replace(/[Ⅴ]/g, '5')
                    .replace(/[Ⅵ]/g, '6')
                    .replace(/[Ⅶ]/g, '7')
                    .replace(/[Ⅷ]/g, '8')
                    .replace(/[Ⅸ]/g, '9')
                    .toLowerCase();

                this.$store.commit('addAbility', ability);
            });
            this.$db.working.get(1).then(record => {
                if (!record) return false;
                let abilities = JSON.parse(record.abilities);
                abilities.forEach((ability, index) => {
                    if (!ability) return false;
                    let payload = {
                        index: index,
                        id: ability.id
                    };
                    this.$store.commit('setUserAbility', payload);
                })
            });
        },
        // methods: {
        //     track () {
        //         this.$ga.page('/')
        //     }
        // }
    }
</script>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 60px;
    }
</style>
